export default __webpack_public_path__ + "img/ghost.e04ee69d.png";